export default __webpack_public_path__ + "static/media/intro-scene-clouds-long.d69c7772.png";